export type SiteAdminSectionTone = 'secondary' | 'primary' | 'surface';

export interface SiteAdminSectionPresentation {
  icon: string;
  tone: SiteAdminSectionTone;
  description: string | null;
}

export function siteAdminSectionPresentation(label: string | null): SiteAdminSectionPresentation {
  switch (label) {
    case 'Perfil':
      return {
        icon: 'person',
        tone: 'secondary',
        description: 'Configura los datos personales y preferencias de visualización del administrador.',
      };
    case 'Aprendizaje':
      return {
        icon: 'school',
        tone: 'primary',
        description: 'Gestión de itinerarios formativos, expedientes académicos y catálogos.',
      };
    case 'Credenciales':
      return {
        icon: 'verified',
        tone: 'surface',
        description: 'Control de insignias digitales y certificaciones oficiales del sitio.',
      };
    case 'Cuentas':
      return {
        icon: 'group',
        tone: 'primary',
        description: 'Usuarios, grupos, matrículas y campos del perfil.',
      };
    case 'Permisos':
      return {
        icon: 'admin_panel_settings',
        tone: 'secondary',
        description: 'Roles y permisos del sistema.',
      };
    case 'Cursos':
      return {
        icon: 'menu_book',
        tone: 'primary',
        description: 'Categorías, cursos y recursos de aprendizaje.',
      };
    case 'Contenido':
      return {
        icon: 'library_books',
        tone: 'primary',
        description: 'Biblioteca, evaluaciones, banco de preguntas y archivos multimedia.',
      };
    case 'Calificaciones':
      return {
        icon: 'grade',
        tone: 'primary',
        description: 'Libro de calificaciones y configuración relacionada.',
      };
    case 'Seguimiento':
      return {
        icon: 'insights',
        tone: 'secondary',
        description: 'Progreso y expedientes académicos.',
      };
    case 'Multimedia':
    case 'Examen práctico':
      return {
        icon: 'directions_car',
        tone: 'primary',
        description: 'Pauta del examen práctico, con las mismas faltas y reglas de reprobación.',
      };
    case 'Vehículos':
      return {
        icon: 'garage',
        tone: 'primary',
        description: 'Patente, marca, modelo y transmisión de los vehículos usados en el examen práctico.',
      };
    case 'H5P':
      return {
        icon: 'extension',
        tone: 'secondary',
        description: 'Plugins y contenido interactivo.',
      };
    case 'Contratos':
      return {
        icon: 'description',
        tone: 'secondary',
        description: 'Plantillas y contratos de servicios generados al matricular alumnos.',
      };
    case 'Políticas legales':
      return {
        icon: 'policy',
        tone: 'secondary',
        description: 'Políticas de tratamiento de datos y consentimientos legales de la plataforma.',
      };
    case 'Tiempo de sesión':
      return {
        icon: 'timer',
        tone: 'secondary',
        description: 'Límites de inactividad y tiempo máximo de aprendizaje por sesión y por día.',
      };
    case 'Tema':
      return {
        icon: 'palette',
        tone: 'primary',
        description: 'Apariencia y sistema de diseño.',
      };
    case 'Estado del servidor':
      return {
        icon: 'dns',
        tone: 'secondary',
        description: 'Diagnóstico y herramientas de desarrollo.',
      };
    default:
      return {
        icon: 'folder',
        tone: 'secondary',
        description: null,
      };
  }
}
